import React from 'react';
import { Divider, Flex, Skeleton, VStack, Text, Stack, Button } from '@chakra-ui/react';
import { PurchaseGiftCardsButton } from '@olo-web/components/atoms/PurchaseGiftCardsButton';
import { useMerchant, useMerchantGroup } from '@domain/merchants/queries';
import { useModalDispatch } from '@olo-web/client-state';
import { useGiftCardUrl } from '@domain/merchants/hooks/useGiftCardUrl';
import { EModalTypes, EModalSubTypes } from '@olo-web/types/enums';
import { useScreenSizeState } from '@olo-web/client-state';

export const OrderingUnavailableHeaderDetails = () => {
  const { data: merchant } = useMerchant();
  const { data: merchantGroup } = useMerchantGroup();
  const { isMdDown } = useScreenSizeState();
  const modalDispatch = useModalDispatch();
  const giftCardUrl = useGiftCardUrl();

  const handleAddressClick = () => {
    modalDispatch({
      type: 'OPEN_MODAL',
      payload: {
        modalKey: EModalTypes.MERCHANT_LOCATION,
        subType: EModalSubTypes.LOCATION.MAP,
      },
    });
  };

  return (
    <VStack
      w="100%"
      mt={{ base: 0, md: 4 }}
      spacing={4}
      alignItems={{ base: 'center', md: 'flex-start' }}
    >
      <Flex
        flexDir={{ base: 'column', md: 'row' }}
        align={{ base: 'flex-start', md: 'center' }}
        justify={{ base: 'center', md: 'space-between' }}
        w="100%"
      >
        <Flex
          align="center"
          px={{ base: 4, md: 0 }}
          pb={{ base: 2, md: 0 }}
          justify="flex-start"
          wrap="wrap"
        >
          {!merchant ? (
            <Skeleton w="600px" h="30px" />
          ) : (
            <Flex
              onClick={() => merchantGroup?.merchants?.length && handleAddressClick()}
              w="100%"
              position="relative"
            >
              <Text fontWeight="semibold" mr={2} fontSize="sm">
                From:
              </Text>
              <Stack
                w="100%"
                alignItems="flex-start"
                spacing={{ base: 0, md: 3 }}
                direction={{ base: 'column', md: 'row' }}
              >
                <Text data-testid="location-address" fontSize="sm">
                  {merchant?.locationString}
                </Text>
                {merchantGroup?.merchants?.length && (
                  <Button
                    fontSize="sm"
                    variant="link"
                    fontWeight="semibold"
                    color="primary.350"
                    textDecor="underline"
                    _hover={{
                      cursor: 'pointer',
                      color: 'primary.400',
                    }}
                    data-testid="change-locations-button"
                  >
                    Change location
                  </Button>
                )}
              </Stack>
            </Flex>
          )}
        </Flex>
        {isMdDown && giftCardUrl && <Divider />}
        <PurchaseGiftCardsButton />
      </Flex>
    </VStack>
  );
};
